import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/* eslint-disable no-undef */
export default {
  init() {

    /**************************************************************
    -> Pageload animation
    **************************************************************/
    function pagePrivateRentalsLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-private-rentals .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-private-rentals .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-private-rentals .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    }
    pagePrivateRentalsLoadAnimation()


    /**************************************************************
    -> Private rentals intro anim on scroll
    **************************************************************/
    function inViewAnimPrivateRentalsIntro() {
      gsap.fromTo('.intro-private-rentals-landing .intro-container h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.75,
        duration: 0.25,
        scrollTrigger: '.intro-private-rentals-landing',
      })

      gsap.fromTo('.intro-private-rentals-landing .intro-container p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.75,
        duration: 0.25,
        scrollTrigger: '.intro-private-rentals-landing .intro-container p',
      })
    }
    inViewAnimPrivateRentalsIntro();

    /**************************************************************
    -> private rentals filters anim on scroll
    **************************************************************/
    function inViewAnimPrivateRentalsFilters() {
      gsap.fromTo('.filters-taxonomy-type-landing' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.75,
        duration: 0.25,
        scrollTrigger: '.filters-taxonomy-type-landing',
      })
    }
    inViewAnimPrivateRentalsFilters();

    /**************************************************************
    -> Home News anim on scroll
    **************************************************************/
    function inViewAnimRentalsItems() {
      gsap.fromTo('.all-rentals-list .wrap-rentals-list .rental-item' , 
      { opacity: 0},
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        ease: 'linear',
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.all-rentals-list',
      })

    }
    inViewAnimRentalsItems();


    let countBed = 1;
    let countCapacity = 1;
    const output = document.querySelector('.counter-output-bed');
    const outputCapacity = document.querySelector('.counter-output-capacity');
    // const outputBed = document.querySelector('.facetwp-facet-number_of_bed input.facetwp-number')

    /**************************************************************
    -> On page load check if queries are setup and update counter
    **************************************************************/
   $(document).on('facetwp-loaded', function() {
    if (FWP.facets['number_of_bed'].length >= 1) {
      countBed = parseInt(FWP.facets['number_of_bed']);
      output.setAttribute('value', countBed)
    }

    // if (outputBed) {
      FWP.facets['number_of_bed'] = [countBed];
    // }
   })

   /**************************************************************
    -> Clear Subfilter if Main filter is reset or refilter
    **************************************************************/
   $(document).on('facetwp-refresh', function() {
    const countriesSubFilter = document.querySelector('.facetwp-facet-rentals_by_countries');
    if (FWP.facets.single_private_rentals_sort_by_destination.length === 0) {
      if (countriesSubFilter) {
        countriesSubFilter.classList.remove('active')
      }
    } else {
      if (countriesSubFilter) {
        countriesSubFilter.classList.add('active')
      }
    }

    if (FWP.facets.single_private_rentals_sort_by_destination.length.length === 0) {
      // eslint-disable-next-line no-undef
      FWP.facets['rentals_by_countries'] = [];
    }
  });

    /**************************************************************
    -> Handle Inc/Dec for number of bed filter
    **************************************************************/
   const filterBedNumbers = () => {
    // let count = 1;
    const inc = document.querySelector('.counter-inc-bed');
    const dec = document.querySelector('.counter-dec-bed');

    const increment = () => {
      countBed = parseInt(countBed + 1)
      output.setAttribute('value', countBed)
      FWP.facets['number_of_bed'] = [countBed];
      FWP.fetch_data(); // Change a facet value
      FWP.set_hash();
    }

    inc.addEventListener('click', () => {
      increment()
    })

    const decrement = () => {
      countBed = parseInt(countBed - 1)

      if (countBed < 1) {
        countBed = 1;
        dec.classList.add('disable')
        return
      } else {
        if (dec.classList.contains('disable')) {
          dec.classList.remove('disable')
        }
      }
    
      output.setAttribute('value', countBed)
      FWP.facets['number_of_bed'] = [countBed];
      FWP.fetch_data();
      FWP.set_hash();
    }

    dec.addEventListener('click', () => {
      decrement()
    })
  }
  filterBedNumbers();


   /**************************************************************
    -> Handle Inc/Dec for number of capacity filter
    **************************************************************/
   const filterCapacityNumbers = () => {
    // let count = 1;
    const inc = document.querySelector('.counter-inc-capacity');
    const dec = document.querySelector('.counter-dec-capacity');

    const increment = () => {
      countCapacity = parseInt(countCapacity + 1)
      outputCapacity.setAttribute('value', countCapacity)
      FWP.facets['max_capacity'] = [countCapacity];
      FWP.fetch_data(); // Change a facet value
      FWP.set_hash();
    }

    inc.addEventListener('click', () => {
      increment()
    })

    const decrement = () => {
      countCapacity = parseInt(countCapacity - 1)

      if (countCapacity < 1) {
        countCapacity = 1;
        dec.classList.add('disable')
        return
      } else {
        if (dec.classList.contains('disable')) {
          dec.classList.remove('disable')
        }
      }
    
      outputCapacity.setAttribute('value', countCapacity)
      FWP.facets['max_capacity'] = [countCapacity];
      FWP.fetch_data();
      FWP.set_hash();
    }

    dec.addEventListener('click', () => {
      decrement()
    })
  }
  filterCapacityNumbers();


  // /**************************************************************
    // -> Toggle refine filters on click
  // **************************************************************/
  const toggleRefineFilters = () => {
    const refineButton = document.querySelector('.refine-button-js');
    const refineFilters = document.querySelector('.wrap-refine-filters');

    refineButton.addEventListener('click', () => {
      refineButton.classList.toggle('active')
      refineFilters.classList.toggle('open')
    })
  }
  toggleRefineFilters();

    

    // /**************************************************************
    // -> Show hide sub filter if first filter has a choice
    // **************************************************************/
    // $(document).on('facetwp-loaded', function() {
    //   const countriesSubFilter = document.querySelector('.sub-sorting-by-countries');
    //   // eslint-disable-next-line no-undef
    //   if (FWP) {
    //     // eslint-disable-next-line no-undef
    //     if (FWP.facets.by_destination.length === 0) {
    //       countriesSubFilter.classList.remove('active')
    //     } else {
    //       countriesSubFilter.classList.add('active')
    //     }
    //   }
    // });

    // /**************************************************************
    // -> Clear Subfilter if Main filter is reset or refilter
    // **************************************************************/
    // $(document).on('facetwp-refresh', function() {
    //   // eslint-disable-next-line no-undef
    //   if (FWP.facets['by_destination'].length === 0) {
    //     // eslint-disable-next-line no-undef
    //     FWP.facets['by_countries'] = [];
    //   }
    // });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/private-rentals.js